import { render, staticRenderFns } from "./HourMax.vue?vue&type=template&id=0040f035"
import script from "./HourMax.vue?vue&type=script&lang=js"
export * from "./HourMax.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports